import React from 'react';
import I18n from 'app/i18n';
import type {ParticipationProgress} from 'app/interfaces/articles/ArticleInterface';

interface PromoNewCardTurnoverProps {
    isPermanent: boolean
    isParticipating: boolean
    progress?: ParticipationProgress | null
}

const PromoNewCardTurnover = ({
    isPermanent,
    isParticipating,
    progress
}: PromoNewCardTurnoverProps): React.ReactElement | null => {
    const turnoverRequired = progress?.turnover_required ?? 0;

    if (turnoverRequired <= 0 || isPermanent && !isParticipating) {
        return null;
    }

    const turnoverCurrent = progress?.bets_turnover ?? 0;
    const turnoverProgressPercentage = Math.min(progress?.percentage ?? 0, 100);

    return <div className="promo-new-card__turnover">
        {isParticipating
            ? <>
                <div className="promo-new-card__turnover-header promo-new-card__turnover-header--participating">
                    <span>
                        {I18n.t('bonuses_page.turnover')}
                    </span>
                    <p className="promo-new-card__turnover-value">
                        <span>${Math.trunc(turnoverCurrent)}</span>
                        {' / '}
                        ${Math.trunc(turnoverRequired)}
                    </p>
                </div>
                <div className="promo-new-card__turnover-progress">
                    <div
                        className="promo-new-card__turnover-progress-fill"
                        style={{width: `${turnoverProgressPercentage}%`}}
                    />
                </div>
            </>
            : <div className="promo-new-card__turnover-header">
                <span>
                    {I18n.t('bonuses_page.turnover')} ${Math.trunc(turnoverRequired)}
                </span>
            </div>}
    </div>;
};

export default PromoNewCardTurnover;
